/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AdminFhirIdBackgroundImageFileIdGet$Params {
  fhirId: string;
  id: string;
}

export function adminFhirIdBackgroundImageFileIdGet(http: HttpClient, rootUrl: string, params: AdminFhirIdBackgroundImageFileIdGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdBackgroundImageFileIdGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as OrganizationStrictHttpResponse<void>;
    })
  );
}

adminFhirIdBackgroundImageFileIdGet.PATH = '/Admin/{fhirId}/BackgroundImageFile/{id}';
